import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { isToday } from 'date-fns';
import { useState } from 'react';
import CalendarCell from '../CalendarCell/index';
import { createSchedule } from '../utils/createSchedule';
function DayView(props) {
    const { schedule = [], date, isEditable, source, } = props;
    const [showAddIcon, setShowAddIcon] = useState();
    const scheduleDays = createSchedule(schedule);
    let today = isToday(new Date(date));
    let currentDaySchedule = scheduleDays[new Date(date).toDateString()];
    return (_jsx(Box, Object.assign({ sx: {
            width: '100%',
            height: '100vh',
            borderTop: '1.5px solid #DCDFE4',
            borderLeft: '1.5px solid #DCDFE4',
        } }, { children: _jsx(Box, Object.assign({ sx: {
                padding: '20px',
                width: '150px'
            } }, { children: _jsx(CalendarCell, { date: date, isToday: today, schedule: currentDaySchedule, isEditable: isEditable, source: source, showSchedule: showAddIcon, setShowschedule: setShowAddIcon, cellType: "day" }) })) })));
}
export default DayView;
